/**
 * Public API for the components directory
 */

import { SmartPlayerAudio } from './SmartPlayerAudio';
import { SmartPlayerAudioTrackSelector } from './SmartPlayerAudioTrackSelector';
import { SmartPlayerChannelControllerPanel } from './SmartPlayerChannelControllerPanel';
import { SmartPlayerError } from './SmartPlayerError';
import { SmartPlayerFastForward } from './SmartPlayerFastForward';
import { SmartPlayerFrameNav } from './SmartPlayerFrameNav';
import { SmartPlayerFullscreen } from './SmartPlayerFullscreen';
import { SmartPlayerPlayPause } from './SmartPlayerPlayPause';
import { SmartPlayerRewind } from './SmartPlayerRewind';
import { SmartPlayerRoot } from './SmartPlayerRoot';
import { SmartPlayerSkip } from './SmartPlayerSkip';
import { SmartPlayerSpeed } from './SmartPlayerSpeed';
import { SmartPlayerTimecode } from './SmartPlayerTimecode';
import { SmartPlayerTimeline } from './SmartPlayerTimeline';
import { SmartPlayerToolbar } from './SmartPlayerToolbar';
import { SmartPlayerViewport } from './SmartPlayerViewport';
import { SmartPlayerVolume } from './SmartPlayerVolume';

//~ Add exports here...
export * from './SmartPlayerAudio';
export * from './SmartPlayerAudioTrackSelector';
export * from './SmartPlayerChannelControllerPanel';
export * from './SmartPlayerError';
export * from './SmartPlayerFastForward';
export * from './SmartPlayerFrameNav';
export * from './SmartPlayerFullscreen';
export * from './SmartPlayerPlayPause';
export * from './SmartPlayerRewind';
export * from './SmartPlayerRoot';
export * from './SmartPlayerSkip';
export * from './SmartPlayerSpeed';
export * from './SmartPlayerTimecode';
export * from './SmartPlayerTimeline';
export * from './SmartPlayerToolbar';
export * from './SmartPlayerViewport';
export * from './SmartPlayerVolume';

export const SmartPlayer = Object.assign(SmartPlayerRoot, {
    Audio: SmartPlayerAudio,
    AudioTracks: SmartPlayerAudioTrackSelector,
    ChannelController: SmartPlayerChannelControllerPanel,
    Error: SmartPlayerError,
    FastForward: SmartPlayerFastForward,
    FrameNav: SmartPlayerFrameNav,
    Fullscreen: SmartPlayerFullscreen,
    PlayPause: SmartPlayerPlayPause,
    Rewind: SmartPlayerRewind,
    Skip: SmartPlayerSkip,
    Speed: SmartPlayerSpeed,
    Timecode: SmartPlayerTimecode,
    Timeline: SmartPlayerTimeline,
    Toolbar: SmartPlayerToolbar,
    Viewport: SmartPlayerViewport,
    Volume: SmartPlayerVolume,
});
